export default __webpack_public_path__ + "static/4_27-9238309a94cc6ba742ad3cd31760f48a.png";